import React, { useState } from "react";
import Styles from "./Navbar.module.css";
import { ReactComponent as UpMark } from "../../assets/images/UpMark.svg";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../Redux/Slices/authSlice";

const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(/[\s_-]+/);
  if (parts.length >= 2)
    return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
};

const NavProfile = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state?.persistedReducer);

  const [listOpen, setListOpen] = useState(false);

  const handleClose = () => setListOpen(false);

  const handleLogout = async () => {
    dispatch(logout());
    localStorage.setItem("OTC_V2_TOKEN", null);
    localStorage.clear();
    sessionStorage.clear();
    handleClose();
    window.location = "/login";
  };

  const userName = data?.user?.user?.userName;
  const initials = getInitials(userName);

  return (
    <div className={Styles.profileWrapper}>
      <div
        className={Styles.profileMainContainer}
        onClick={() => setListOpen((prev) => !prev)}
      >
        <div className={Styles.userAvatar}>{initials}</div>

        <span className={Styles.compDIsplayName}>{userName}</span>

        <KeyboardArrowDownIcon
          className={`${Styles.arrow} ${listOpen ? Styles.rotate : ""}`}
        />
      </div>

      {listOpen && (
        <div
          className={Styles.user_profile_container}
          onMouseLeave={handleClose}
        >
          <div className={Styles.user_profile_DropdownHeader}>
            <UpMark />
          </div>

          <div className={Styles.user_profile_list_mainCont}>
            <div
              className={`${Styles.each_list_user} ${Styles.logout_item}`}
              onClick={handleLogout}
            >
              <LogoutIcon className={Styles.logout_icon} />
              <div className={Styles.section_head_log}>Logout</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NavProfile;
